/** Permisos del módulo Presupuestos SA — asignación por usuario (solo administración). */
import React, { useState, useEffect } from 'react';
import api from '@/api/axios';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';

const COLS = [['modulo', 'Presupuestos SA'], ['costos', 'Costos SA'], ['config', 'Configuración SA'], ['costos_edit', 'Editar costos Soluarq']];

export const PermisosSA = ({ onClose }) => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/sa/permisos').then((r) => setUsers(r.data.usuarios || []))
      .catch((e) => toast.error(e?.response?.data?.detail || 'Error al cargar permisos'))
      .finally(() => setLoading(false));
  }, []);

  const toggle = async (u, campo, val) => {
    setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, [campo]: val } : x)));
    try {
      await api.put(`/sa/permisos/${u.id}`, { [campo]: val });
      toast.success(`${u.name}: ${COLS.find(([k]) => k === campo)[1]} ${val ? 'activado' : 'desactivado'}`);
    } catch (e) {
      setUsers((prev) => prev.map((x) => (x.id === u.id ? { ...x, [campo]: !val } : x)));
      toast.error(e?.response?.data?.detail || 'No se pudo guardar');
    }
  };

  const filtrados = users.filter((u) => !q || (u.name || '').toLowerCase().includes(q.toLowerCase()));

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[640px] max-h-[92vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Permisos — Presupuestos SA</DialogTitle></DialogHeader>
        <p className="text-[11px] text-[var(--text-muted)]">
          <b>Presupuestos SA</b>: acceso al módulo (cotizadores y vendedores autorizados). <b>Costos SA</b>: ver costeo interno, costos y utilidad.
          <b> Configuración SA</b>: catálogo técnico, variables, reglas, costos estándar, utilidad/IVA y empresa/PDF.
          <b> Editar costos Soluarq</b>: cambiar costos vigentes del Catálogo Soluarq (requiere motivo; queda auditado).
          Los roles de administración/gerencia tienen todo automáticamente.
        </p>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar usuario…" className="h-9" data-testid="permsa-buscar" />
        {loading ? <p className="text-sm text-[var(--text-muted)]">Cargando…</p> : (
          <div className="border border-[var(--border)] rounded-lg overflow-x-auto">
            <table className="w-full text-xs" data-testid="permsa-tabla">
              <thead>
                <tr className="bg-[var(--bg)] text-[var(--text-muted)] text-left uppercase text-[9px]">
                  <th className="px-2 py-2">Usuario</th>
                  <th className="px-2 py-2">Rol</th>
                  {COLS.map(([k, l]) => <th key={k} className="px-2 py-2 text-center">{l}</th>)}
                </tr>
              </thead>
              <tbody>
                {filtrados.map((u) => (
                  <tr key={u.id} className="border-t border-[var(--border)]" data-testid={`permsa-row-${u.id}`}>
                    <td className="px-2 py-1.5 font-semibold">{u.name}</td>
                    <td className="px-2 py-1.5 text-[var(--text-muted)] capitalize">{u.role}</td>
                    {COLS.map(([k]) => (
                      <td key={k} className="px-2 py-1.5 text-center">
                        {u.admin_rol ? (
                          <span className="text-emerald-500 font-bold" title="Automático por rol">✓ auto</span>
                        ) : (
                          <Switch checked={!!u[k]} onCheckedChange={(v) => toggle(u, k, v)} data-testid={`permsa-${k}-${u.id}`} />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
